import { Box } from '@material-ui/core'
import cx from 'classnames'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import BackIconCD from '../../shared/icons/back_icon_CD'
import CloseIconCD from '../../shared/icons/close_icon_CD'
import NavbarContext from './context'
import buildStyles from './styles'
import AppImage from '../../components/AppImage'
import { useWindowSize } from '../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../constants/constants'
import Logo from '../../assets/logoAlfa.png'
import AppContext from '../context'

const Navbar = () => {
  const { state: navbarState } = useContext(NavbarContext)
  const { state: appState } = useContext(AppContext)

  const styles = buildStyles()
  const navigate = useNavigate()
  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  const isBackVisible = navbarState.isBackButtonVisible
  const isCloseVisible = navbarState.isCloseButtonVisible
  return (
    <>
      <Box className={styles.container}>
        {isBackVisible && (
          <div
            className={styles.item}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(navbarState.backPathname)
            }}
          >
            <BackIconCD />
          </div>
        )}

        {/* After the decision to temporarily remove the logo */}
        {/* {!isMobile && (
          <img
            src={Logo}
            alt="logo"
            className={styles.item}
            style={{
              height: '60px',
            }}
          />
        )} */}

        {isCloseVisible && (
          <div
            className={cx(styles.item, styles.closeIcon)}
            onClick={() => navigate(navbarState.closePathname)}
          >
            <CloseIconCD />
          </div>
        )}
      </Box>
    </>
  )
}

export default Navbar
